<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>


<div class="container py-4">

  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-lg-12 mb-4 mb-lg-0">

      <div class="row">

        <div class="col-12">

          @if (alertSucesso === true) {
            <div class="body-senha">
              <div class="div-alert text-center">
                <img class="mt-4" src="/assets/img/success.png" alt="Sucesso" width="82px">
                <p class="titulo-alert mt-4"> {{ alertSucessoSubtitulo }} </p>
                <div class="footer-alert">
                  <p class="subtitulo-alert"> {{ alertSucessoMensagem }} </p>
                  <button class="botao-secundario-outline mt-3"
                  (click)="fecharAlertSucesso()">SAIR</button>
                </div>
              </div>
            </div>
          }

          @if (erroSenha === true) {
            <div class="body-senha">
              <div class="div-alert text-center">
                <img class="mt-4" src="/assets/img/error.png" width="82px" alt="Erro">
                <p class="titulo-alert mt-4 c-danger"> {{ alertErroSubtitulo }} </p>
                <div class="footer-alert bg-danger">
                  <p class="subtitulo-alert"> {{ alertErroMensagem }} </p>
                  <button class="btn-borda-branca btn-font-branco btn-grande-vermelho mt-3"
                  (click)="fecharAlertErro()">SAIR</button>
                </div>
              </div>
            </div>
          }
          <!-- essa table e referente aos perfis coodenacao, analista e 2 via -->
          @if (perfilCheck === true) {
            <table class="table table-hover border-bottom mt-4" aria-describedby="essa table e referente aos perfis coodenacao, analista e 2 via ">
              <thead>
                <tr>
                  <th scope="col">
                    <div class="switch__container">
                      <input id="switch-shadow2"
                        class="switch switch--shadow"
                        type="checkbox"
                        [checked]="switchAll"
                        (click)="selectAll($event)"
                        (keydown)="selectAll($event)"
                        [attr.aria-label]="'Ativar todos'">
                      <label for="switch-shadow2"></label>
                    </div>
                  </th>
                  <th scope="col" class="upper">Funcionalidade disponível</th>
                  <th scope="col" class="upper">Todos</th>
                  <th scope="col" class="upper">Inclusão</th>
                  <th scope="col" class="upper">Alteração</th>
                  <th scope="col" class="upper">Exclusão</th>
                  <th scope="col" class="upper">Visualização</th>
                </tr>
              </thead>
              <tbody>
                @for (list of listaPermissoes; track list; let i = $index) {
                  <tr>
                    <td>
                      <div class="switch__container">
                        <input id="{{list.descricao}}1" class="switch switch--shadow" type="checkbox"
                          [checked]="list.flagAtivo"
                          (click)="permissoesTableClick(list.descricao, 'flagAtivo' , $event)"
                          (keydown)="permissoesTableClick(list.descricao, 'flagAtivo' , $event)"
                          [attr.aria-label]="'Ativar ' + list.descricao">
                        <label [attr.for]="list.descricao + '1'"></label></div>
                      </td>
                      <!-- tem que trocar o ID e o For dos checkBox -->
                      <td>{{list.menu}} {{list.descricao}}</td>
                      <td class="text-center">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{list.descricao}}2"
                            (click)="selectAllPermissao(list.descricao, i, $event)"
                            (keydown)="selectAllPermissao(list.descricao, i, $event)"
                            [disabled]="isCheckboxDisabled(i)"
                            [checked]="list.todosSelecionado"
                            name="{{list.descricao}}2"
                            title="{{list.descricao}}2"
                            [attr.aria-label]="'Selecionar todos ' + list.descricao">
                          <label class="form-check-label" for="{{list.descricao}}2"></label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{list.descricao}}3"
                            [disabled]="isCheckboxDisabled(i)"
                            [checked]="list.flagIncluir"
                            (click)="permissoesTableClick(list.descricao, 'flagIncluir', $event)"
                            (keydown)="permissoesTableClick(list.descricao, 'flagIncluir', $event)"
                            name="{{list.descricao}}3"
                            title="{{list.descricao}}3"
                            [attr.aria-label]="'Incluir ' + list.descricao">
                          <label class="form-check-label" for="{{list.descricao}}3"></label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{list.descricao}}4"
                            [checked]="list.flagAlterar"
                            [disabled]="isCheckboxDisabled(i)"
                            (click)="permissoesTableClick(list.descricao, 'flagAlterar' , $event)"
                            (keydown)="permissoesTableClick(list.descricao, 'flagAlterar', $event)"
                            name="{{list.descricao}}4"
                            title="{{list.descricao}}4"
                            [attr.aria-label]="'Alterar ' + list.descricao">
                          <label class="form-check-label" for="{{list.descricao}}4"></label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{list.descricao}}5"
                            [checked]="list.flagExcluir"
                            [disabled]="isCheckboxDisabled(i)"
                            (click)="permissoesTableClick(list.descricao, 'flagExcluir' , $event)"
                            (keydown)="permissoesTableClick(list.descricao, 'flagExcluir', $event)"
                            name="{{list.descricao}}5"
                            title="{{list.descricao}}5"
                            [attr.aria-label]="'Excluir ' + list.descricao">
                          <label class="form-check-label" for="{{list.descricao}}5"></label>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{list.descricao}}6"
                            [checked]="list.flagImprimir"
                            [disabled]="isCheckboxDisabled(i)"
                            (click)="permissoesTableClick(list.descricao, 'flagImprimir' , $event)"
                            (keydown)="permissoesTableClick(list.descricao, 'flagImprimir', $event)"
                            name="{{list.descricao}}6"
                            title="{{list.descricao}}6"
                            [attr.aria-label]="'Imprimir ' + list.descricao">
                          <label class="form-check-label" for="{{list.descricao}}6"></label>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }

            <!-- essa table e referente ao perfil filial -->

            @if (perfilCheck === false) {
              <table class="table table-hover border-bottom mt-4" aria-describedby="essa table referente-se ao perfil filial">
                <thead>
                  <tr>
                    <th scope="col">
                      <div class="switch__container">
                        <input id="switch-shadow3" class="switch switch--shadow" type="checkbox"
                          (click)="selectAll($event)"
                          (keydown)="selectAll($event)"
                          [attr.aria-label]="'Selecionar todos'">
                        <label for="switch-shadow3"></label>
                      </div>
                    </th>
                    <th scope="col" class="upper">Funcionalidade disponível</th>
                    <th scope="col" class="upper" class="text-center">Visualização</th>
                  </tr>
                </thead>
                <tbody>
                  @for (list of listaPermissoes; track list; let i = $index) {
                    <tr>
                      <td>
                        <div class="switch__container">
                          <input id="{{list.descricao}}11" class="switch switch--shadow" type="checkbox"
                            [checked]="list.flagAtivo"
                            (click)="permissoesTableClick(list.descricao, 'flagAtivo', $event)"
                            (keydown)="permissoesTableClick(list.descricao, 'flagAtivo', $event)"
                            [attr.aria-label]="'Ativar ' + list.descricao">
                          <label for="{{list.descricao}}11"></label>
                        </div>
                      </td>
                      <!-- tem que trocar o ID e o For dos checkBox -->
                      <td>{{list.menu}} {{list.descricao}}</td>
                      <td class="text-center">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{list.descricao}}9"
                            [checked]="list.flagImprimir"
                            [disabled]="isCheckboxDisabled(i)"
                            (click)="permissoesTableClick(list.descricao, 'flagImprimir', $event)"
                            (keydown)="permissoesTableClick(list.descricao, 'flagImprimir', $event)"
                            name="{{list.descricao}}9"
                            title="{{list.descricao}}6"
                            [attr.aria-label]="'Imprimir ' + list.descricao">
                          <label class="form-check-label" for="{{list.descricao}}9"></label>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }

          </div>
        </div>
        <div class="text-center mb-5 mt-3">
          <button type="button " (click)='salvarPermissoes()'
          class="btn-borda-verde btn-font-branco btn-grande-verde">SALVAR</button>
        </div>
      </div>
    </div>
  </div>